<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="24"
    viewBox="0 0 28 24">
    <path
      d="M21.2499 0H2.75006C1.23303 0 0 1.23303 0 2.75006V15.2499C0 16.767 1.23303 18 2.75006 18H21.2499C22.767 18 24 16.767 24 15.2499V2.75006C24 1.23303 22.767 0 21.2499 0ZM7.5 3.99994C8.87805 3.99994 9.99994 5.12201 9.99994 6.50006C9.99994 7.87793 8.87805 9 7.5 9C6.12195 9 5.00006 7.87793 5.00006 6.50006C5.00006 5.12201 6.12195 3.99994 7.5 3.99994ZM12 13.2501C12 13.6641 11.664 14.0001 11.25 14.0001H3.75C3.336 14.0001 3 13.6641 3 13.2501V12.75C3 11.233 4.23303 9.99994 5.75006 9.99994H9.24994C10.767 9.99994 12 11.233 12 12.75V13.2501ZM20.25 14.0001H14.7501C14.3361 14.0001 14.0001 13.6641 14.0001 13.2501C14.0001 12.8361 14.3361 12.5001 14.7501 12.5001H20.25C20.664 12.5001 21 12.8361 21 13.2501C21 13.6641 20.664 14.0001 20.25 14.0001ZM20.25 9.99994H14.7501C14.3361 9.99994 14.0001 9.66394 14.0001 9.24994C14.0001 8.83594 14.3361 8.49994 14.7501 8.49994H20.25C20.664 8.49994 21 8.83594 21 9.24994C21 9.66394 20.664 9.99994 20.25 9.99994ZM20.25 6H14.7501C14.3361 6 14.0001 5.664 14.0001 5.25C14.0001 4.836 14.3361 4.5 14.7501 4.5H20.25C20.664 4.5 21 4.836 21 5.25C21 5.664 20.664 6 20.25 6Z"
      fill="var(--primary)"
      fill-rule="nonzero"
      transform="translate(2.5 2)"/>
  </svg>
</template>

<script>
export default {};
</script>

<style>
</style>